var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 69,
    viewBox: "0 0 31 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2657 59.9317C14.2657 59.9317 -0.462968 49.9 0.388844 32.1539C0.468305 26.804 1.69497 21.5334 3.98598 16.6981C6.27699 11.8629 9.57898 7.57562 13.6689 4.12591C14.1469 3.71984 14.5266 3.21075 14.7796 2.63687C15.0326 2.06299 15.1522 1.43925 15.1295 0.8125C16.0463 2.78562 15.8971 30.2722 15.9934 33.487C16.3663 45.9923 15.298 57.5711 14.2657 59.9317Z",
    fill: "url(#paint0_linear_50_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9919 68.1874L15.1848 67.5883C15.1848 67.5883 15.4254 58.4445 12.1168 57.8021C9.95117 55.2803 12.4368 -49.856 20.3534 57.4435C18.8514 58.2054 17.7021 59.5185 17.1459 61.1083C16.8477 63.4562 16.7961 65.8288 16.9919 68.1874Z",
    fill: "url(#paint1_linear_50_45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 59.3542C22.7803 55.7322 26.465 50.8191 28.5948 45.1859C30.7246 39.5527 31.2119 33.4307 30.0001 27.5315C26.4629 11.927 18.0867 6.79685 17.1844 4.83816C16.4058 3.6185 15.7413 2.32972 15.1992 0.988159L15.8658 44.4667C15.8658 44.4667 14.4846 57.754 17.9688 59.3542Z",
    fill: "url(#paint2_linear_50_45)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_45",
    x1: -0.878113,
    y1: 33.9105,
    x2: 23.7634,
    y2: 25.6581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_45",
    x1: 4.84425,
    y1: 35.1071,
    x2: 25.6142,
    y2: 42.1552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_50_45",
    x1: 12.4608,
    y1: 0.677479,
    x2: 21.6431,
    y2: 58.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoicon);
export default __webpack_public_path__ + "static/media/mongoicon.708a9a93cbca158935e83201605edcd2.svg";
export { ForwardRef as ReactComponent };